import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.start-reconciliation-session.views.ReconcileAccountForm`

export default defineMessages({
  lastStatementDateLabel: {
    id: `${scope}.lastStatementDateLabel`,
    defaultMessage: 'Last statement date',
  },
  currentStatementDateLabel: {
    id: `${scope}.currentStatementDateLabel`,
    defaultMessage: 'Current statement date',
  },
  currentStatementDateRequiredError: {
    id: `${scope}.currentStatementDateRequiredError`,
    defaultMessage: 'Current statement date is required',
  },
  endingBalanceLabel: {
    id: `${scope}.endingBalanceLabel`,
    defaultMessage: 'Ending balance',
  },
  endingBalancePlaceholder: {
    id: `${scope}.endingBalancePlaceholder`,
    defaultMessage: 'Ending balance',
  },
  endingBalanceInvalidError: {
    id: `${scope}.endingBalanceInvalidError`,
    defaultMessage: 'Enter a valid amount (max 999999999.99, 2 decimals)',
  },
  attachStatementTitle: {
    id: `${scope}.attachStatementTitle`,
    defaultMessage: 'Attach statement',
  },
  attachStatementOptionalTitle: {
    id: `${scope}.attachStatementOptionalTitle`,
    defaultMessage: 'Attach statement (optional)',
  },
  browseUploadButton: {
    id: `${scope}.browseUploadButton`,
    defaultMessage: 'Browse & upload CSV',
  },
  noFilesAttachedText: {
    id: `${scope}.noFilesAttachedText`,
    defaultMessage: 'No files attached (max size 25.0 MB)',
  },
  // Exact Angular parity string (BHV-027).
  invalidFileTypeError: {
    id: `${scope}.invalidFileTypeError`,
    defaultMessage: 'Only .qif and .csv files are allowed',
  },
  fileTooLargeError: {
    id: `${scope}.fileTooLargeError`,
    defaultMessage: 'File exceeds the maximum size of 25.0 MB',
  },
  removeAttachmentAriaLabel: {
    id: `${scope}.removeAttachmentAriaLabel`,
    defaultMessage: 'Remove statement attachment',
  },
  importByStatementDateCheckbox: {
    id: `${scope}.importByStatementDateCheckbox`,
    defaultMessage: 'Import credit card items based on current statement date',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  beginMatchingButton: {
    id: `${scope}.beginMatchingButton`,
    defaultMessage: 'Begin matching',
  },
  importStatementButton: {
    id: `${scope}.importStatementButton`,
    defaultMessage: 'Import statement',
  },
})
